import React from 'react';
import { OnboardingTransitions } from '../../../services/aiIntelligenceService';

const ATTACK_TO_DEFENCE = [
  { value: 'immediate-press', label: 'Immediate Press', description: 'Counter-press within 5 seconds of losing the ball' },
  { value: 'recover-shape', label: 'Recover Shape', description: 'Drop back quickly into defensive shape' },
  { value: 'foul-tactically', label: 'Tactical Foul', description: 'Stop the counter-attack with a tactical foul' },
  { value: 'delay-and-press', label: 'Delay & Press', description: 'Nearest player delays while team recovers' },
  { value: 'situational', label: 'Situational', description: 'Depends on where the ball is lost' },
];

const DEFENCE_TO_ATTACK = [
  { value: 'quick-counter', label: 'Quick Counter', description: 'Exploit space immediately with pace' },
  { value: 'controlled-build', label: 'Controlled Build-Up', description: 'Secure possession first, then progress' },
  { value: 'direct-forward', label: 'Direct Forward', description: 'Play forward quickly to the front line' },
  { value: 'switch-play', label: 'Switch Play', description: 'Change the point of attack to exploit weak side' },
  { value: 'patient-progression', label: 'Patient Progression', description: 'Move the ball through the thirds methodically' },
];

interface TransitionsStepProps {
  data: OnboardingTransitions;
  onChange: (data: OnboardingTransitions) => void;
}

export function TransitionsStep({ data, onChange }: TransitionsStepProps) {
  return (
    <div>
      <h2 className="text-xl font-bold text-gray-900 mb-2">Transitions</h2>
      <p className="text-sm text-gray-600 mb-6">
        How does your team react in the moments of transition — when possession changes?
      </p>

      {/* Attack to Defence */}
      <div className="mb-8">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Attack → Defence <span className="text-red-500">*</span>
        </label>
        <p className="text-xs text-gray-500 mb-3">
          What happens when your team loses the ball?
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {ATTACK_TO_DEFENCE.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange({ ...data, attackToDefence: item.value })}
              className={`text-left p-3 rounded-lg border-2 transition-all min-h-[44px] ${
                data.attackToDefence === item.value
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <span className="text-sm font-medium text-gray-900">{item.label}</span>
              <span className="block text-xs text-gray-500 mt-0.5">{item.description}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Defence to Attack */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Defence → Attack <span className="text-red-500">*</span>
        </label>
        <p className="text-xs text-gray-500 mb-3">
          What happens when your team wins the ball back?
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {DEFENCE_TO_ATTACK.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => onChange({ ...data, defenceToAttack: item.value })}
              className={`text-left p-3 rounded-lg border-2 transition-all min-h-[44px] ${
                data.defenceToAttack === item.value
                  ? 'border-blue-500 bg-blue-50'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              <span className="text-sm font-medium text-gray-900">{item.label}</span>
              <span className="block text-xs text-gray-500 mt-0.5">{item.description}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
